import { createApiHandler } from './handler';

const mealSets = {
  apiClient: null,
  path: '/franchises/meal-sets',

  setClient(apiClient) {
    this.apiClient = apiClient;
    this.initApiHandler();
  },

  initApiHandler() {
    Object.assign(this, createApiHandler(this.apiClient, this.path));
  },
};

export default mealSets;
